import toast from "react-hot-toast";
import { PatchClientReportOptions } from "../types";
import { ClientReportType } from "../../../../types/ClientReportType";
import { useCreateDraftMailMutation } from "../../../../services/useremails";
import { usePatchReportMutation } from "../../../../services/clientreports";
import { PatchReportRequest } from "../../../../services/clientreports/types";
import { SaveDraftResponse } from "../../../../hooks/useMailMessageForm";

export const usePatchReport = (report: ClientReportType | null | undefined) : PatchClientReportOptions => {
    const [patch, { isLoading: isPatchingReport }] = usePatchReportMutation();
    const [createDraft, { isLoading: isSavingDraftEmail }] = useCreateDraftMailMutation();
    const { projectId } = report ?? { masterAccountId: '', projectId: '', id: '' };

    const patchReport = (request: PatchReportRequest, mailForm: FormData | null = null) : Promise<ClientReportType> => new Promise((resolve, reject) => {
        const requestPromise = !mailForm
            ? patch({ projectId, ...request }).unwrap()
            : createDraft({ userId: request.publishDetails?.emailOptions?.mailSenderId, request: mailForm })
                .unwrap()
                .then((mailResponse: SaveDraftResponse) => {
                    const mailRequest : PatchReportRequest = {
                        ...request,
                        publishDetails: {
                            ...request.publishDetails!,
                            emailOptions: {
                                ...request.publishDetails!.emailOptions!,
                                mailMessageId: mailResponse.id
                            }
                        }
                    }
                    return patch({ projectId, ...mailRequest }).unwrap();
                });
        
        return toast.promise(requestPromise, {
            loading: 'Updating Report details...',
            success: (data: ClientReportType) => {
                resolve(data);
                return `Report updated successfully.`;
            },
            error: (err) => {
                reject();
                const { errors: { generalErrors } } = err.data || { errors: { generalErrors: [] } };
                const message = generalErrors && generalErrors.length > 0
                    ? generalErrors[0]
                    : `There was a problem updating the report details.`
                return message;
            }
        });
    });

    return { 
        isLoading: isPatchingReport || isSavingDraftEmail,
        patchReport
    };
};